/**
 * @generated SignedSource<<c6df0628f36cb4b1f256847a152bb891>>
 * @relayHash 891edaf6e87e299a147c6e9c32e3d7ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bf33084190f671d57d5417699ce10b46fdcb269408000caf2a15c2f7353fc69a

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FormsQuery } from './FormsQuery.graphql';

const node: PreloadableConcreteRequest<FormsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "bf33084190f671d57d5417699ce10b46fdcb269408000caf2a15c2f7353fc69a",
    "metadata": {},
    "name": "FormsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
